export const SecteurEntreprise = [
  'Public',
  'Prive',
] as const

export type SecteurEntreprise = typeof SecteurEntreprise[number]

export const SecteurEntrepriseLibelle: {
  [key in SecteurEntreprise]: string
} = {
  Public: 'Employeur public',
  Prive: 'Employeur privé',
} as const
